import getItemByItemKey from '../getItemByItemKey/internal'
import { errorOfType, errorTypes } from '../../utilities/Errors'

const getKitByKitId = firestore => async ({ kitId }) => {
	if (!kitId) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getKitByKitId')
	}
	try {
		const kitRef = firestore.collection('kits').doc(kitId)
		const kitSnap = await kitRef.get()

		if (!kitSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { kitId }))
		}
		const kit = kitSnap.data()
		if (kit.deleted) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { kitId, reason: 'deleted' }))
		}
		if (!kit.items && !kit.items.length) {
			return Promise.reject(errorOfType(errorTypes.INVALIDOBJECT, 'kit', kit))
		}

		// TODO: should add these (document id) to all documents
		kit.kitId = kitSnap.id

		// load the full items
		const itemTasks = kit.items.map(async (itemEntry) => {
			try {
				const { item } = await getItemByItemKey(firestore)({ itemKey: itemEntry.itemKey })
				itemEntry.item = item // eslint-disable-line no-param-reassign
			} catch (error) {
				console.log(error, `Error loading item ${itemEntry.itemKey}`)
			}
		})

		// wait for all async tasks
		await Promise.all(itemTasks)

		return { kit }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, kitId, exception)
	}
}

export default getKitByKitId



// WEBPACK FOOTER //
// ./src/dataservices/getKitByKitId/internal.js